<template>
    <footer class="footer is-left">
        <p class="b3 reg">{{ appVersion }}</p>
    </footer>
</template>
<script>
export default {
    data() {
        return {
            appVersion: process.env.VUE_APP_VERSION || 'sandbox'
        }
    }
}
</script>
<style scoped>
footer.footer {
    width: -webkit-fill-available;
    margin-top: auto;
}

@-moz-document url-prefix() {
    footer.footer {
        width: 100%; /* Firefox-specific fallback */
    }
}

p {
    margin: 0;
}
</style>